import { useAlert } from "hooks/alerts/useAlert";
import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "services/api.service";
import { OauthApplication } from "types/oauthApplication";

export default function useOauthApplications() {
  const { alertSuccess } = useAlert();
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["oauth_applications"],
    queryFn: () =>
      api.get<{ oauthApplications: OauthApplication[] }>("/oauth_applications").then((res) => ({ data: res.data })),
  });

  const deleteOauthApplications = useCallback((uid: string) => {
    return api.delete(`/oauth_applications/${uid}`).then(() => {
      alertSuccess("Oauth application subscription successfully deleted");
      refetch();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    oauthApplications: data?.data.oauthApplications,
    isLoading,
    isError,
    refetch,
    deleteOauthApplications,
  };
}
